export class ExpertBioVideo {
  ID: number;
  LangCode: string;
  ExpertID: number;
  BrightcoveID: string;
  HighResUploaded: boolean;
  LowResUploaded: boolean;
}
